export const CREATE_USER_FORM_SHIPPING_PLAN_DETAILS = 'CREATE_USER_FORM_SHIPPING_PLAN_DETAILS'


export const CREATE_SHIPPING_PLAN_DETAILS_POST_REQUEST = 'CREATE_SHIPPING_PLAN_POST_DETAILS_REQUEST'
export const CREATE_SHIPPING_PLAN_DETAILS_POST_SUCCESS = 'CREATE_SHIPPING_PLAN_POST_DETAILS_SUCCESS'
export const CREATE_SHIPPING_PLAN_DETAILS_POST_FAILURE = 'CREATE_SHIPPING_PLAN_POST_DETAILS_FAILURE'


export const CREATE_SHIPPING_PLAN_CHECK_POST_REQUEST = 'CREATE_SHIPPING_PLAN_POST_CHECK_REQUEST'
export const CREATE_SHIPPING_PLAN_CHECK_POST_SUCCESS = 'CREATE_SHIPPING_PLAN_POST_CHECK_SUCCESS'
export const CREATE_SHIPPING_PLAN_CHECK_POST_FAILURE = 'CREATE_SHIPPING_PLAN_POST_CHECK_FAILURE'


export const SHIPPING_PLAN_DETAILS_USERFORM_RESET = 'SHIPPING_PLAN_DETAILS_USERFORM_RESET'


export const CREATE_SHIPPING_PLAN_DETAILS_GET_REQUEST = 'CREATE_SHIPPING_PLAN_GET_DETAILS_REQUEST'
export const CREATE_SHIPPING_PLAN_DETAILS_GET_SUCCESS = 'CREATE_SHIPPING_PLAN_DETAILS_GET_SUCCESS'
export const CREATE_SHIPPING_PLAN_DETAILS_GET_FAILURE = 'CREATE_SHIPPING_PLAN_DETAILS_GET_FAILURE'


export const CREATE_SHIPPING_PLAN_DETAILS_FROM_DROP_GET_REQUEST = 'CREATE_SHIPPING_PLAN_GET_DETAILS_FROM_DROP_REQUEST'
export const CREATE_SHIPPING_PLAN_DETAILS_FROM_DROP_GET_SUCCESS = 'CREATE_SHIPPING_PLAN_FROM_DROP_DETAILS_GET_SUCCESS'
export const CREATE_SHIPPING_PLAN_DETAILS_FROM_DROP_GET_FAILURE = 'CREATE_SHIPPING_PLAN_DETAILS_FROM_DROP_GET_FAILURE'





export const DELETE_SHIPPING_PLAN_DETAILS_REQUEST = 'DELETE_SHIPPING_PLAN_DETAILS_REQUEST'
export const DELETE_SHIPPING_PLAN_DETAILS_SUCCESS = 'DELETE_SHIPPING_PLAN_DETAILS_SUCCESS'
export const DELETE_SHIPPING_PLAN_DETAILS_FAILURE = 'DELETE_SHIPPING_PLAN_DETAILS_FAILURE'


